import React, { useRef } from 'react';
import NewsEvents from './NewsEvents';

import { Testimonials } from './Testimonials';
import { Getintouch } from './Getintouch';
import ClientLogo from './ClientLogo';


function CasinoBetting() {

  const swiperRef = useRef(null);

  const logos = [
    {
      url: "https://everymatrix.com/clients/bet-at-home/",
      img: "https://everymatrix.com/wp-content/uploads/2021/07/Frame.svg",
      alt: "bet-at-home",
    },
    {
      url: "https://everymatrix.com/clients/tipico/",
      img: "https://everymatrix.com/wp-content/uploads/2019/03/tipico-1.svg",
      alt: "Tipico",
    },
    {
      url: "https://everymatrix.com/clients/opap/",
      img: "https://everymatrix.com/wp-content/uploads/2020/08/pngegg-1.png",
      alt: "OPAP",
    },
    {
      url: "https://everymatrix.com/clients/norsk-tipping/",
      img: "https://everymatrix.com/wp-content/uploads/2019/03/Frame-2.svg",
      alt: "Norsk Tipping",
    },
    {
      url: "https://everymatrix.com/clients/szerencsejatek-zrt/",
      img: "https://everymatrix.com/wp-content/uploads/2023/01/szerencsejatek.svg",
      alt: "Szerencsejáték ZRT",
    },
    {
      url: "https://everymatrix.com/clients/veikkaus/",
      img: "https://everymatrix.com/wp-content/uploads/2022/10/veikkaus-logo.png",
      alt: "Veikkaus",
    },
    {
      url: "https://everymatrix.com/clients/pinnacle/",
      img: "https://everymatrix.com/wp-content/uploads/2024/10/image-60.png",
      alt: "Pinnacle",
    },
    {
      url: "https://everymatrix.com/clients/intralot/",
      img: "https://everymatrix.com/wp-content/uploads/2022/09/Frame-36.svg",
      alt: "Intralot",
    },
    {
      url: "https://everymatrix.com/clients/flutter-entertainment/",
      img: "https://everymatrix.com/wp-content/uploads/2019/12/Group-3.svg",
      alt: "Flutter Entertainment",
    },
    {
      url: "https://everymatrix.com/clients/betparx/",
      img: "https://everymatrix.com/wp-content/uploads/2023/10/betparx.svg",
      alt: "betPARX",
    },
    {
      url: null,
      img: "https://everymatrix.com/wp-content/uploads/2024/11/BetGoodwinLogoNew-2-1-3.png",
      alt: "Private: betgoodwin",
    },
    {
      url: "https://everymatrix.com/clients/malta-national-lottery/",
      img: "https://everymatrix.com/wp-content/uploads/2022/07/national-lottery.svg",
      alt: "Malta National Lottery",
    },
  ];
  return (
    <>
      <section class="intro betting-home">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h1>Odds on Your Side</h1>
              <h2>From OddsMatrix Sportsbook to Sports Data Feeds and Feed Aggregator, we offer complete sports betting solutions for competitive bookmakers. </h2>
              <nav class="product-submenu">
                <ul>
                  <li class="active">
                    <a href="/fantasy-betting">Overview</a>
                  </li>
                  <li>
                    <a href="/fantasy-betting/sportsbook" data-ga-click="hero-sportsbook">Sportsbook</a>
                  </li>
                  <li>
                    <a href="/fantasy-betting/omnichannel/" data-ga-click="hero-omnichannel">Omnichannel</a>
                  </li>
                  <li>
                    <a href="/fantasy-betting/esports-services/">Esports Services</a>
                  </li>
                  <li>
                    <a href="/" target="_blank">Data Feeds</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <a href="#explore" class="explore"></a>
      </section>
      <section class="product-overview1 sec-padd grayp" id="explore">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
              <h2 class="section-title">Why OddsMatrix?</h2>
              <div class="row">
                <div class="col-md-9 mx-auto">
                  <p class="description">OddsMatrix Sports Betting Software Solutions features competitive sports and esports coverage, real-time and reliable betting data, unrivalled number of markets and industry-leading accuracy. From sportsbook platform to data feeds, you can leverage our solutions in full or pick what you need.</p>
                </div>
              </div>
            </div>
          </div>
          <div className='row g-md-5 g-4 pt-5 align-items-center'>
            <div className='col-md-6'>
              <div class="inner circle_list pt-5">
                <ul>
                  <li>Modern technology, launched 2009, fully rewritten 2019</li>
                  <li>Online, retail, and omnichannel solution</li>
                  <li>Comprehensive sportsbook and esports coverage </li>
                  <li>Industry-leading market uptime on live events</li>
                  <li>Maximize betting margin and profit </li>
                  <li>Tailored sports betting solutions for every market </li>
                  <li>Real-time Sports Data APIs and Data Feeds </li>
                  <li>Dedicated Account Management </li>
                  <li>Experienced Managed Trading Services team </li>
                  <li>24/7 Technical and Trading support </li>
                </ul>
              </div>
            </div>
            <div className='col-md-6'>
              <img src='https://everymatrix.com/wp-content/uploads/2021/03/OM-Why-soccer-player.png' alt='images' />
            </div>

          </div>
        </div>
      </section>

      <section class="product-summary sec-padd">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <h2 class="section-title">Explore OddsMatrix</h2>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="inner">
                <div class="img-holder"><img src="https://everymatrix.com/wp-content/uploads/2019/04/more-games-and-more-possibilities.svg" alt="MORE GAMES AND MORE POSSIBILITIES " /></div>
                <h3><a data-ga-click="explore-more-games-and-more-possibilities">Broadened Game Selection and Opportunities</a></h3>
                <p>CasinoEngine offers seamless access to over 27,800 casino games from more than 317 game providers.</p>
                <a class="read-more">Read more</a>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="inner">
                <div class="img-holder"><img src="https://everymatrix.com/wp-content/uploads/2019/04/full-featured-back-office.svg" alt="Tailored business setups " /></div>
                <h3><a data-ga-click="explore-tailored-business-setups">Customizable Business Setups</a></h3>
                <p>From premium content to a full turnkey casino platform, we offer tailored business setups to meet client needs.</p>
                <a class="read-more">Read more</a>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="inner">
                <div class="img-holder"><img src="https://everymatrix.com/wp-content/uploads/2019/04/modular-platform-architecture.svg" alt="Casino Platform Features" /></div>
                <h3><a data-ga-click="explore-casino-platform-features">Features of the Casino Platform</a></h3>
                <p>CasinoEngine provides a fully-managed, robust casino platform solution tailored to clients’ needs.</p>
                <a class="read-more">Read more</a>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="inner">
                <div class="img-holder"><img src="https://everymatrix.com/wp-content/uploads/2019/05/multi-jurisdictional-gambling-compliance.svg" alt="Compliant in Multiple Jurisdictions" /></div>
                <h3><a data-ga-click="explore-compliant-in-multiple-jurisdictions">Regulatory Compliance in Multiple Jurisdictions</a></h3>
                <p>CasinoEngine is certified in various jurisdictions and continuously adapts to meet regulatory frameworks.</p>
                <a class="read-more">Read more</a>
              </div>
            </div>

          </div>
        </div>
      </section>

      <NewsEvents />
      <Testimonials />

      {/* <section className="product-clients sec-padd-b grayp">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="section-title">Our Clients</h2>
              <p>
                Servicing more than 300 operators from different jurisdictions,
                we are constantly <br />
                striving to offer our clients the best range of services, value
                and support in the market.
              </p>
              <ul className="list-clients row">
                {logos.map((logo, index) => (
                  <ClientLogo logo={logo} key={index} />

                ))}
              </ul>
              <div className="text-center">
                <a
                  className="btn btn_blue"
                >
                  View more clients
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <Getintouch/>
    </>
  )
}

export default CasinoBetting